import { IThunkApi } from '../../types/redux';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AuthRequiredError } from 'shared/errors';
import { fetchOfferFromHistory } from 'shared/services/fetchOfferFromHistory';
import { IFailOfferFromHistoryPayload, ISuccessOfferFromHistoryPayload } from 'shared/types/offersHistory';

export interface IGetOfferFromHistoryParams {
  cianId: number;
}

interface IThunkApiExtended extends IThunkApi {
  rejectValue: IFailOfferFromHistoryPayload;
}

export const getOfferFromHistory = createAsyncThunk<
  ISuccessOfferFromHistoryPayload,
  IGetOfferFromHistoryParams,
  IThunkApiExtended
>('offersHistory/getOfferFromHistory', async (parameters, { extra: context, rejectWithValue }) => {
  try {
    const data = await fetchOfferFromHistory(context, { parameters });

    return {
      id: parameters.cianId,
      data,
    };
  } catch (e) {
    if (e instanceof AuthRequiredError) {
      return rejectWithValue({ isAuthError: true });
    }

    return rejectWithValue({ isError: true });
  }
});
